export default __webpack_public_path__ + "static/media/Holiday-Camp-banner.png";